import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getWorkFlowCountSlice = createApi(`GetWorkflowCountSlice`,"GET");

const GetWorkflowCountSlice = createSlice({
  name: 'GetWorkflowCountSlice',
  initialState: {
    data: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWorkFlowCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWorkFlowCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getWorkFlowCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetWorkflowCountSlice.reducer;